
// Adds 'section-anim-in' (once) and 'section-in-view' (while visible) to every
// .shopify-section as it approaches the viewport. The bottom root margin starts
// the reveal a fifth of a viewport early, so a section is already settled and
// its lazy images already requested by the time it scrolls into view.
// https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
(function addInViewportClass(elements) {
  const threshold = window.Shopify && Shopify.designMode ? 0 : 0.15;
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('section-anim-in');
        entry.target.classList.add('section-in-view');
        entry.target.dispatchEvent(new CustomEvent('section:in-viewport'))
      } else {
        entry.target.classList.remove('section-in-view');
        entry.target.dispatchEvent(new CustomEvent('section:out-of-viewport'))
      }
    });
  }, {
    root: null,
    rootMargin: '0px 0px 20% 0px',
    threshold: [0, threshold, 1],
  });

  elements.forEach((el) => {
    observer.observe(el);
  });
})(document.querySelectorAll('.shopify-section'))
